import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/ai-agents/{agentId}/run-agent']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];

const runAiAgent = async ({ agentId, questionnaireTemplateId, creatorId, fieldInputData, questionnaireId, userWorkflowId, rowIndiciesToRun, stateOfFiling }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaire-templates/{creatorId}/{questionnaireTemplateId}/ai-agents/{agentId}/run-agent', { agentId, creatorId, questionnaireTemplateId });
  const data = await formsBackendClient.post(path, { fieldInputData, questionnaireId, rowIndiciesToRun, stateOfFiling, userWorkflowId});
  return data.data;
};

export default runAiAgent;